import React from 'react';
import { motion } from 'framer-motion';
import { Filter, MessageSquare, ShieldCheck } from 'lucide-react';
export function UniqueMethod() {
  return <section className="bg-navy text-white py-24 px-6" data-id="element-324">
      <div className="max-w-3xl mx-auto" data-id="element-325">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-326">
          <h3 className="text-amber-500 font-bold tracking-wider text-sm uppercase mb-3" data-id="element-327">
            El Método de la Clave de Paz
          </h3>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-offwhite mb-6" data-id="element-328">
            Protocolo de Respuesta Blindada
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg text-slate-300 leading-relaxed space-y-6 mb-12" data-id="element-329">
          <p data-id="element-330">
            👉 <strong data-id="element-331">No es psicología barata ni frases de autoayuda.</strong>
          </p>
          <p data-id="element-332">
            Es un{' '}
            <strong className="text-white font-bold bg-slate-800 px-2 py-1 rounded" data-id="element-333">
              sistema de gestión de crisis
            </strong>{' '}
            diseñado para que te vuelvas <em data-id="element-334">"invisible"</em> al drama.
          </p>
          <p data-id="element-335">
            Aprendés a filtrar el ruido del dato, a{' '}
            <strong data-id="element-336">responder como un escribano</strong> y a poner una pared de
            concreto entre tu vida privada y el caos de tu ex.
          </p>
          <p className="text-xl text-white font-medium border-l-4 border-amber-500 pl-4 mt-8" data-id="element-337">
            La prioridad absoluta son tus hijos, y para cuidarlos a ellos,{' '}
            <strong data-id="element-338">primero tenés que recuperar tu centro vos.</strong>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-339">
          {[{
          icon: Filter,
          title: 'Filtrar',
          desc: 'Separar el ruido del dato útil.'
        }, {
          icon: MessageSquare,
          title: 'Responder',
          desc: 'Comunicación aséptica y logística.'
        }, {
          icon: ShieldCheck,
          title: 'Blindar',
          desc: 'Bloquear el reingreso del conflicto.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3 + i * 0.1
        }} className="bg-slate-800 p-6 rounded-xl border border-slate-700 text-center flex flex-col items-center" data-id="element-340">
              <div className="bg-slate-700 p-4 rounded-full mb-4 text-amber-500" data-id="element-341">
                <item.icon size={28} data-id="element-342" />
              </div>
              <h4 className="text-white font-bold text-xl mb-2" data-id="element-343">
                {item.title}
              </h4>
              <p className="text-slate-400 text-sm" data-id="element-344">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}